import React from 'react';
export function SectionImage3() {
  return <section className="w-full" data-id="element-118">
      <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1772481005/hf_20260302_180501_44e1e842-f55e-4426-990d-0249a7ee5ba3_nveleu.jpg" alt="Sección promocional 3" className="w-full block" style={{
      display: 'block'
    }} data-id="element-119" />
    </section>;
}